<xm-clinical-notes-widget-view
  [comments]="comments()"
  [title]="title"
  [isLoading]="loading()"
  [usePrimaryText]="settings?.themeWidgetText"
  (downloadRequested)="onDownloadRequested($event)">

  @if (canWrite() && !loading()) {
    <div widget-actions class="mat-button-group mb-3">
      @if (shouldShowDropdown) {
        <!-- Dropdown mode -->
        <button mat-flat-button color="primary" type="button" [matMenuTriggerFor]="templateMenu">
          <span>New Comment</span>
          <mat-icon iconPositionEnd>arrow_drop_down</mat-icon>
        </button>
        <mat-menu #templateMenu="matMenu">
          @for (template of templates; track template.id) {
            <button mat-menu-item (click)="selectTemplate(template.id)">{{ template.name }}</button>
          }
        </mat-menu>
      } @else {
        <!-- Button mode -->
        @for (template of templates; track template.id) {
          <button mat-flat-button color="primary" type="button" (click)="selectTemplate(template.id)">{{template.name}}</button>
          <mat-divider vertical></mat-divider>
        }
      }
    </div>
  }
</xm-clinical-notes-widget-view>
